import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function TextField(theme: Theme) {
  return {
    MuiTextField: {
      defaultProps: {},
      styleOverrides: {
        root: {
          borderColor: theme.palette.primary.light,
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '& .MuiInputBase-input': {
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              padding: '8px 12px',
              color: 'primary',
            },
            '&.Mui-disabled': {
              '& .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${theme.palette.primary[100]}!important`,
              },
            },
          },
        },
      },
    },
  }
}
